import setFaq from './pages/faq';
import setTabs from './pages/abas';
import setPersonalizados from './pages/personalizados';
import setImageAccordion from './pages/image_accordion';
import setCarousel from '../components/carousel';
//addImports

import setTopBar from "../components/topBar";

const Page = {
  init: function () {
    var _this = this;

    setTopBar();

    setFaq();
    setTabs();
    setPersonalizados();
    setImageAccordion();
    setCarousel();
    //calls

  },
};

window.addEventListener('DOMContentLoaded', () => {
  Page.init()
})
